// KWANKGM11010_事前審査案件詳細（職員）
import React from 'react';
import axios from '../../axios';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import FooterPreExaminationProjectDetails from '../../organisms/FooterPreExaminationProjectDetails';
import ManagementStore from '../../organisms/ManagementStore';
import { KeyValue } from '../../types/KeyValue';
import { RequestDetail } from '../../types/CoomonApiDetail';
import StaffNavbar from '../../molecules/StaffNavbar';
import ApplicantAgreement from '../../organisms/ApplicantAgreement';
import GuaranteeAgencyExaminationResult from '../../organisms/GuaranteeAgencyExaminationResult';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  reception_id: number;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  show_error_nav: boolean;
  setIsLoading: (flag: boolean) => void;
  is_sent_to_guaranty_company: boolean;
  is_csv_downloaded: boolean;
  office_list: KeyValue[];
  management_store_cd: string;
  setManagementStoreCd: (value: string) => void;
  callApi: (function_name: string) => Promise<any>;
  guarantor_info: GuarantorInfo;
  guarantee_agency_examination_result_name: string; // 保証機関審査結果
  consent_datetime_privacy: string; // 個人情報の取り扱いに関する同意日時
  consent_datetime_not_antisocial_forces: string; // 反社会勢力等ではないことの表明・確約に関する同意日時
  is_staff: boolean;
  suspicious_irregularity_flg: boolean;
  has_hosho_flg: boolean; // 保証機関連携対象フラグ
}

const PreExaminationDetail: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  reception_id,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  guarantors_num,
  is_loading,
  display_status,
  show_error_nav,
  setIsLoading,
  is_sent_to_guaranty_company,
  is_csv_downloaded,
  office_list,
  management_store_cd,
  setManagementStoreCd,
  callApi,
  guarantor_info,
  guarantee_agency_examination_result_name,
  consent_datetime_privacy,
  consent_datetime_not_antisocial_forces,
  is_staff,
  suspicious_irregularity_flg,
  has_hosho_flg,
}) => {
  const requestCommonApi = async (
    module_name: string,
    is_json: boolean,
    is_blob: boolean,
    detail: RequestDetail[]
  ) => {
    try {
      setIsLoading(true);

      const payload = {
        module_name: module_name,
        is_json: is_json,
        reception_id: reception_id,
        reception_cd: reception_cd,
        detail: detail,
      };

      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/common`,
        payload,
        {
          responseType: is_blob ? 'blob' : 'json',
        }
      );

      // JSONレスポンスの結果がfalseの場合はスローする
      if (!is_blob && !response.data.result) {
        throw response;
      }

      // レスポンスが正常ならresolveを返却する
      setIsLoading(false);
      return response;
    } catch (error) {
      // レスポンスが異常ならrejectを返却する
      setIsLoading(false);
      throw error;
    }
  };

  return (
    <>
      <StaffNavbar user_role="staff" has_loan_aproval_system={false} />
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
        is_staff={is_staff}
        suspicious_irregularity_flg={suspicious_irregularity_flg}
      />
      <ManagementStore
        id="management-store"
        label="管理店"
        need={false}
        value={management_store_cd}
        message=""
        name=""
        placeholder=""
        disabled={false}
        looks_inactive={false}
        sources={office_list}
        handleStoreChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
          setManagementStoreCd(event.target.value)
        }
      />
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      <ApplicantAgreement
        id="applicant-agreement"
        label="お申込人の同意事項"
        need={false}
        disabled={false}
        looks_inactive={false}
        privacy={consent_datetime_privacy}
        not_antisocial_forces={consent_datetime_not_antisocial_forces}
        reception_id={reception_id}
        setIsLoading={setIsLoading}
      />
      <GuaranteeAgencyExaminationResult
        id="applicant-agreement"
        label="保証機関審査結果"
        need={false}
        disabled={false}
        looks_inactive={false}
        result={guarantee_agency_examination_result_name}
      />
      <FooterPreExaminationProjectDetails
        reception_id={reception_id}
        reception_cd={reception_cd}
        is_sent_to_guaranty_company={is_sent_to_guaranty_company}
        is_csv_downloaded={is_csv_downloaded}
        management_store_cd={management_store_cd}
        has_hosho_flg={has_hosho_flg}
        requestCommonApi={requestCommonApi}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default PreExaminationDetail;
